<template>
    <div class="header">
        <NavsComp></NavsComp>
        <WalletComp></WalletComp>
    </div>
</template>
<script>

import WalletComp from './WalletComp.vue'
import NavsComp from './NavsComp.vue'

export default {
    name: "CoalHeader",
    components:{
        WalletComp,
        NavsComp
    }
}
</script>

<style scoped>
.header{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    

}

</style>